import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import { Spacer, spacerSpacing } from '@amzn/dvui/dist/Spacer'
import { Text } from '@amzn/dvui/dist/Text'
import { ShareModal } from '@shared/components/shareModal/shareModal'
import { FeedbackForm } from '../feedbackForm/feedbackForm'
import * as st from './bottomBar.module.scss'
import * as cn from 'classnames'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import { logRefTag } from '@utils'
import { ref } from '@amzn/dv-web-node-reftags'

export interface IBottomBarProps extends AtfTreatmentProps {
  isMobile: boolean
  isPurchaseRestricted: boolean
  isRetail: boolean
  bottomBar: WpsRuntime.atv.wps.BottomBarModelProps
}

const TermsAndConditions = ({ termsText }: {termsText: WpsRuntime.atv.wps.DVString}) => (
  <div className={`avu-full-width ${st.termsAndConditions}`}>
    <Text string={termsText}/>
  </div>
)

export const BottomIconWithLink: React.StatelessComponent<{iconType : IconType}> = props => (
  <div className={st.linkWithIcon}>
    <div className={st.bottomIcon}>
      <Icon className={st.icon} use={props.iconType}/>
    </div>
    {props.children}
  </div>
)

//TODO(AVWebDP-716): Remove temporary component after Redesign experiment
class ScreenSizeLogger extends React.PureComponent {
  componentDidMount(): void {
    logRefTag(ref( `atv_dp_screen_{width}_{height}`, { width: `${screen.width}`, height: `${screen.height}`}))
  }
  render() {
    return(
      <></>
    )
  }
}


export const BottomBarComp = ({ isPurchaseRestricted, isRetail, bottomBar, atfTreatment }: IBottomBarProps) => {

  return (
    !isPurchaseRestricted ? (
      <div className={cn('dv-dp-node-bottom', st.bottomBar, {[st.bottomBarRedesign]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
        {!global.__NATIVEAPP__ && <TermsAndConditions termsText={bottomBar.termsText}/>}
        <Spacer className={st.iconsAndFeedback} space={spacerSpacing.m}>
          <BottomIconWithLink iconType={IconType.SHARE}><ShareModal shareWidgetModel={bottomBar.shareWidgetModel}/></BottomIconWithLink>
          {isRetail && <BottomIconWithLink iconType={IconType.EDIT}>{<FeedbackForm />}</BottomIconWithLink>}
          <BottomIconWithLink iconType={IconType.HELP}>
            <span data-automation-id="get-help-link" data-testid="get-help-link">
              <Text string={bottomBar.helpText}/>
            </span>
          </BottomIconWithLink>
        </Spacer>
        <ScreenSizeLogger/>
      </div>
    ) : null
  )
}

export const BottomBar = BottomBarComp
